import React from "react";
import ExpandMore from "@material-ui/icons/ExpandMore";
import ChevronRight from "@material-ui/icons/ChevronRight";
import { string, bool, func } from "prop-types";
import { connect } from "react-redux";
import { selectUserRole } from "redux/permission/selector";
import { makeSelectedRowId } from "redux/points/selectors";
import { openIssueForm } from "redux/issues/actions";
import styles from "./style.module.scss";

function TittleWrapper(props) {
  return (
    <div className={styles.titleWrapper} tabIndex="0">
      <button
        type="button"
        className={styles.collapse}
        onClick={props.handleCollapse}
      >
        {props.isCollapsed ? <ChevronRight /> : <ExpandMore />}
      </button>
      <div className={styles.box}>
        <span>{props.title}</span>
        <button
          className={
            props.roleCode === "viewer"
              ? styles.deleteAllLabelViewer
              : styles.deleteAllLabel
          }
          type="button"
          disabled={props.roleCode === "viewer"}
          onClick={props.handleDeleleAllLabel}
        >
          <span>{props.deleteAllLabel}</span>
        </button>
      </div>
    </div>
  );
}

TittleWrapper.propTypes = {
  selectedRowId: string,
  handleVerifyIssue: func,
  handleDeleteAnnotation: func,
  handleAddIssue: func,
  isLoading: bool,
};

TittleWrapper.propTypes = {
  title: string,
  deleteAllLabel: string,
  isCollapsed: bool,
  handleCollapse: func,
  handleDeleleAllLabel: func,
  roleCode: string,
};

const mapStateTopProps = (state) => ({
  selectedRowId: makeSelectedRowId(state),
  roleCode: selectUserRole(state),
});

export default connect(mapStateTopProps, { openIssueForm })(TittleWrapper);
